import { Colors } from "../../../consts/Colors";
import ButtonRounded from "../../global/buttons/ButtonRounded";
import QuestionPanel from "./QuestionPanel";

export default class QuestionPanel_3 extends QuestionPanel {
    constructor(scene, x, y, {config, totQuestion}) {
        super(scene, x, y, {
            numquestion: 1,
            totQuestion,
            question: config.question,
            textIndice: config.indice
        });

        this.config = config
        this.buttons = []

        let Y = this.aideButton.y + this.aideButton.height + 60

        // Ajout boutons reponses
        config.reponses.forEach(reponse => {
            let button = new ButtonRounded(this.scene,  this.width/2, 0, {
                width: 410, 
                height: 86,
                text: reponse.text,
                color: Colors.Elmt.Orange,
                hoverColor: Colors.Elmt.Blue,
                borderRadius: 30
            })
            button.isTrue = reponse.isTrue
            button.y = Y + button.height/2
            Y = button.y + button.height/2 + 24
            this.add(button)
            this.buttons.push(button)
            button.setClickFunction((elmt) => {
                this.checkResponse(elmt)
            })
        });
    }


    checkResponse(elmt){
        // On parcours les boutons et on met en forme
        var isTrue = false 
        this.buttons.forEach((button) => {
            this.scene.input.setDefaultCursor('default')

            if(button.isTrue && button == elmt){
                this.lockButtons()
                this.setButtonTrue(button)
                isTrue = true
            }else if(!button.isTrue && button == elmt){
                this.setButtonFalse(button)
                button.disableInteractive()
            }
            
            if(this.tentative >= this.maxTentative){
                button.disableInteractive()
                this.setButtonLocked(button)
                if(button.isTrue){
                    this.setButtonTrue(button)
                }
            }
        })
        
        if(isTrue || this.tentative >= this.maxTentative){
            this.scene.showReponsePopUp({
                text: this.config.correction,
                isTrue: isTrue,
                isLast: true,
                endFunc: () => {
                    this.scene.closePanelQuestion((scene) => {scene.addDebrief();});
                    this.scene.closeReponsePopUp();
                }
            });
        }else{
            this.scene.cameras.main.shake(200, 0.01);
            this.tentative++;
            this.setUnlocked();
        }
    }

    lockButtons(){
        this.buttons.forEach((button) => {
            button.disableInteractive()
        })
    }

    setButtonTrue(button){
        button.background.setFillStyle(Colors.Elmt.Green)
    }

    setButtonFalse(button){
        button.background.setFillStyle(Colors.Elmt.White, 0)
        button.background.setStrokeStyle(4, Colors.Elmt.Red)

        button.textElmt.text = '<class=\"red_crossed\">' + button.textElmt.text + '</class>'
    }

    setButtonLocked(button){
        button.background.setFillStyle(Colors.Elmt.Grey)
    }
}